import SharedNavbar from '../../../components/feature/SharedNavbar';
import SharedFooter from '../../../components/feature/SharedFooter';
import FloatingCallButton from '../../../components/feature/FloatingCallButton';
import ServiceHero from '../components/ServiceHero';
import ServiceContent from '../components/ServiceContent';
import ServiceCTA from '../components/ServiceCTA';

export default function WiringRewiringPage() {
  const serviceData = {
    title: 'Wiring & Rewiring Services',
    subtitle: 'Complete Electrical Wiring Solutions',
    description: 'Whether you\'re renovating, building new, or upgrading old wiring, our licensed electricians provide comprehensive wiring and rewiring services. We ensure your electrical system is safe, compliant, and capable of meeting modern power demands.',
    heroImage: 'https://public.readdy.ai/ai/img_res/cc374b6d01af155a798e09f53f788273.jpg',
    features: [
      {
        icon: 'ri-home-gear-line',
        title: 'Complete Rewiring',
        description: 'Full property rewiring for safety and compliance'
      },
      {
        icon: 'ri-building-line',
        title: 'New Installations',
        description: 'Wiring for new builds and extensions'
      },
      {
        icon: 'ri-arrow-up-circle-line',
        title: 'System Upgrades',
        description: 'Modernize outdated electrical systems'
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Code Compliance',
        description: 'All work meets Australian standards'
      }
    ],
    benefits: [
      'Complete house rewiring',
      'Partial rewiring services',
      'New construction wiring',
      'Renovation electrical work',
      'Switchboard upgrades',
      'Circuit additions',
      'Safety compliance certification',
      'Minimal disruption approach'
    ],
    processSteps: [
      {
        number: '01',
        title: 'Site Inspection',
        description: 'Assess existing wiring and power requirements'
      },
      {
        number: '02',
        title: 'Detailed Quote',
        description: 'Provide comprehensive pricing and timeline'
      },
      {
        number: '03',
        title: 'Professional Installation',
        description: 'Install new wiring with minimal disruption'
      },
      {
        number: '04',
        title: 'Testing & Certification',
        description: 'Complete testing and compliance documentation'
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SharedNavbar />
      <ServiceHero 
        title={serviceData.title}
        subtitle={serviceData.subtitle}
        description={serviceData.description}
        heroImage={serviceData.heroImage}
      />
      <ServiceContent 
        features={serviceData.features}
        benefits={serviceData.benefits}
        processSteps={serviceData.processSteps}
      />
      <ServiceCTA />
      <div className="pb-20 lg:pb-0">
        <SharedFooter />
      </div>
      <FloatingCallButton />
    </div>
  );
}